import InfoDoc from '@intelligence/_locales/en-US/infoDoc';
import MetricSubValue from '@intelligence/_locales/en-US/metricSubValue';

const AST_METRIC_TIPS = InfoDoc.dbi_info_mau_returning;
const ACQUISITIONS_METRIC_TIPS = InfoDoc.dbi_info_acquisition_detail;
const PEAK_CCV_STREAM_HATCHET_METRIC_TIPS = `${InfoDoc.dbi_info_streaming_peakccv} ${InfoDoc.dbi_info_max_selected}`;
const RETENTION_D2_METRIC_TIPS = 'Take the AVG Retention-D2 in selected time interval and valid country range.';
const DIGITAL_UNITS_METRIC_TIPS = InfoDoc.dbi_info_units_indicates;

export const METRICS_TIPS: {
  [key: string]: string;
} = {
  Mobile_RPD_Appannie: InfoDoc.dbi_info_rpd_cumulative_detail,
  'PC_Digital-AST_MScience': AST_METRIC_TIPS,
  PC_ACU_Steam: InfoDoc.dbi_info_acu_avg,
  'PC_Acquisitions%_Newzoo': ACQUISITIONS_METRIC_TIPS,
  'Console_Sales-of-selected-time_famitsu': MetricSubValue.dbi_metric_jptb_sales,
  'Console_Cumulative-Sales-of-the-latest-week_famitsu': MetricSubValue.dbi_metric_jptb_cumulative_sales,
  'Console_Cumulative-Revenue-of-the-latest-week($)_famitsu': MetricSubValue.dbi_metric_jptb_cumulative_revenue,
  'Console_Digital-AST_MScience': AST_METRIC_TIPS,
  'Console_Acquisitions%_Newzoo': ACQUISITIONS_METRIC_TIPS,
  'Streaming_Peak-CCV_Stream-Hatchet': PEAK_CCV_STREAM_HATCHET_METRIC_TIPS,
  'Mobile_Peak-CCV_Stream-Hatchet': PEAK_CCV_STREAM_HATCHET_METRIC_TIPS,
  'PC_Peak-CCV_Stream-Hatchet': PEAK_CCV_STREAM_HATCHET_METRIC_TIPS,
  'Console_Peak-CCV_Stream-Hatchet': PEAK_CCV_STREAM_HATCHET_METRIC_TIPS,
  'Combine_Peak-CCV_Stream-Hatchet': PEAK_CCV_STREAM_HATCHET_METRIC_TIPS,
  'Mobile_Retention-D2_': RETENTION_D2_METRIC_TIPS,
  'Mobile_Retention-D2_Appannie': RETENTION_D2_METRIC_TIPS,

  Mobile_D2_Appannie:
    'Percentage of users who opened the app again on the 2nd day after first time the app was launched by users.',
  Mobile_D3_Appannie:
    'Percentage of users who opened the app again on the 3rd day after first time the app was launched by users.',
  Mobile_D7_Appannie:
    'Percentage of users who opened the app again on the 7th day after first time the app was launched by users.',
  Mobile_D15_Appannie: `
    <p>Percentage of users who opened the app again on the 15th day after first time the app was launched by users.</p>
    <p>data.ai can only provide the retention data on the 15th day, so there is no Annie D14 (双周留存) .</P>
  `,
  Mobile_D31_Appannie: `
    <p>Percentage of users who opened the app again on the 31st day after first time the app was launched by users.</p>
    <P>data.ai can only provide the retention data on the 31st day, so there is no Annie D30 (月留存) .</P>
  `,
  'PC_Digital-Units_MScience': DIGITAL_UNITS_METRIC_TIPS,
  'Console_Digital-Units_MScience': DIGITAL_UNITS_METRIC_TIPS,
  'Combine_Sales-of-the-Latest-Week_famitsu': MetricSubValue.dbi_metric_jptb_sales_latest_week,
  'Combine_Revenue-of-the-Latest-Week_famitsu': MetricSubValue.dbi_metric_jptb_revenue_latest_week,
  'PC_Digital-Units_gsd': InfoDoc.dbi_info_gsd_digitalUnits,
  'PC_Physical-Units_gsd': InfoDoc.dbi_info_gsd_physicalUnits,
  'Combine_Digital-Units_gsd': InfoDoc.dbi_info_gsd_digitalUnits,
  'Combine_Physical-Units_gsd': InfoDoc.dbi_info_gsd_physicalUnits,
  'Console_Digital-Units_gsd': InfoDoc.dbi_info_gsd_digitalUnits,
  'Console_Physical-Units_gsd': InfoDoc.dbi_info_gsd_physicalUnits,
};

export const METRICS_CALC_METHODS_TIPS: {
  [key: string]: string;
} = {
  'Take the MAX value in selected time interval.': InfoDoc.dbi_info_max_selected,
  'Take the AVG value in selected time interval.': InfoDoc.dbi_info_avg_selected,
  'Take the SUM value in selected time interval.': InfoDoc.dbi_info_sum_selected,
  'Take the WEIGHTED AVG value in selected time interval.': InfoDoc.dbi_info_weighted_avg,
};
